// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import type { UserRole } from '../types';
import { ROLE_PERMISSIONS } from './rolePermissions';

export interface MockPersona {
  email: string;
  first_name: string;
  last_name: string;
  user_id: string;
  role: UserRole;
  permissions: string[];
  siteIds: string[];
}

/**
 * Mock personas for each role — used by MockRoleSwitcher to simulate
 * different user identities during local development.
 */
export const MOCK_PERSONAS: Record<UserRole, MockPersona> = {
  admin: {
    email: 'admin@test.com',
    first_name: 'Alice',
    last_name: 'Admin',
    user_id: '22222222-0000-0000-0000-000000000001',
    role: 'admin',
    permissions: ROLE_PERMISSIONS.admin.permissions,
    siteIds: ['simple-dc-001', 'GA-10'],
  },
  operations_manager: {
    email: 'opsmanager@test.com',
    first_name: 'Oscar',
    last_name: 'Operations',
    user_id: '22222222-0000-0000-0000-000000000003',
    role: 'operations_manager',
    permissions: ROLE_PERMISSIONS.operations_manager.permissions,
    siteIds: ['simple-dc-001', 'GA-10'],
  },
  operator: {
    email: 'operator@test.com',
    first_name: 'Olivia',
    last_name: 'Operator',
    user_id: '22222222-0000-0000-0000-000000000002',
    role: 'operator',
    permissions: ROLE_PERMISSIONS.operator.permissions,
    siteIds: ['simple-dc-001', 'GA-10'],
  },
  executive: {
    email: 'executive@test.com',
    first_name: 'Eve',
    last_name: 'Executive',
    user_id: '22222222-0000-0000-0000-000000000004',
    role: 'executive',
    permissions: ROLE_PERMISSIONS.executive.permissions,
    siteIds: ['simple-dc-001', 'GA-10'],
  },
};
